var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08566 8.01342C3.195 5.80441 4.89682 3.94743 7.0009 2.65004C9.10498 1.35265 11.5284 0.66597 14.0003 0.666749C17.5937 0.666749 20.6123 1.98675 22.9203 4.14008L19.0977 7.96408C17.715 6.64275 15.9577 5.96942 14.0003 5.96942C10.527 5.96942 7.58699 8.31608 6.54033 11.4668C6.27366 12.2668 6.12166 13.1201 6.12166 14.0001C6.12166 14.8801 6.27366 15.7334 6.54033 16.5334C7.58833 19.6854 10.527 22.0308 14.0003 22.0308C15.7937 22.0308 17.3203 21.5574 18.515 20.7574C19.2076 20.3014 19.8005 19.7097 20.2579 19.0181C20.7154 18.3264 21.0278 17.5492 21.1763 16.7334H14.0003V11.5761H26.5577C26.715 12.4481 26.8003 13.3574 26.8003 14.3027C26.8003 18.3641 25.347 21.7827 22.8243 24.1027C20.619 26.1401 17.6003 27.3334 14.0003 27.3334C12.2492 27.3341 10.515 26.9897 8.89705 26.3199C7.27906 25.6501 5.80893 24.668 4.57067 23.4297C3.33242 22.1915 2.35032 20.7213 1.68051 19.1034C1.01069 17.4854 0.666292 15.7512 0.666993 14.0001C0.666993 11.8481 1.18166 9.81342 2.08566 8.01342Z",
    fill: "#BBC6D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.6544a6e33627d9252ba37059b96b3eea.svg";
export { ForwardRef as ReactComponent };